const categories = [
  "Electronics", "PCB", "Robotics", "Drone", "EV", "Automotive",
  "Aerospace", "Medical Device", "Industrial", "Consumer",
  "IoT", "3D Printing", "CNC", "Injection Moulding",
];

export default function ProjectInfoStep({ formData, updateField }) {
  return (
    <div>
      <div className="grid sm:grid-cols-2 gap-6 mb-6">
        <label className="block">
          <span className="block text-sm font-medium text-gray-700 mb-1.5">Project Name</span>
          <input
            value={formData.projectName}
            onChange={(e) => updateField("projectName", e.target.value)}
            placeholder="EV Battery Enclosure v3"
            className="w-full border border-gray-200 rounded-xl px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
          />
        </label>

        <label className="block">
          <span className="block text-sm font-medium text-gray-700 mb-1.5">Expected Quantity</span>
          <input
            type="number"
            value={formData.expectedQuantity}
            onChange={(e) => updateField("expectedQuantity", e.target.value)}
            placeholder="25"
            className="w-full border border-gray-200 rounded-xl px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
          />
        </label>
      </div>

      <div className="mb-6">
        <span className="block text-sm font-medium text-gray-700 mb-3">Category</span>
        <div className="flex flex-wrap gap-2">
          {categories.map((cat) => {
            const isSelected = formData.category === cat;
            return (
              <button
                key={cat}
                type="button"
                onClick={() => updateField("category", cat)}
                className={`text-sm font-medium px-4 py-2 rounded-full border transition ${
                  isSelected
                    ? "bg-indigo-600 border-indigo-600 text-white"
                    : "bg-white border-gray-200 text-gray-700 hover:border-indigo-300"
                }`}
              >
                {cat}
              </button>
            );
          })}
        </div>
      </div>

      <label className="block mb-6">
        <span className="block text-sm font-medium text-gray-700 mb-1.5">Description</span>
        <textarea
          value={formData.description}
          onChange={(e) => updateField("description", e.target.value)}
          placeholder="Describe your prototype and application..."
          rows={4}
          className="w-full border border-gray-200 rounded-xl px-4 py-3 text-sm resize-y focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
        />
      </label>

      <label className="block">
        <span className="block text-sm font-medium text-gray-700 mb-1.5">Target Delivery Date</span>
        <input
          type="date"
          value={formData.targetDeliveryDate}
          onChange={(e) => updateField("targetDeliveryDate", e.target.value)}
          className="w-full border border-gray-200 rounded-xl px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
        />
      </label>
    </div>
  );
}